// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"e4b2c6ed","976":"6c75e804"}[chunkId] + ".chunk.js";
};